/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddtoWishlist from "./AddtoWishlist";
import PriceHtml from "./PriceHtml";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";


import { getPriceSymbole } from "../Helper";
import Rating from "../rating/Rating";

const ProductCard = React.forwardRef(({ product: e }, ref) => {
  const symbol = getPriceSymbole();
  const GalleryImages = JSON.parse(e.images);
  const [currentImgIndex, setCurrentImgIndex] = useState(0);
  const [hovering, setHovering] = useState(false);
  let timerRef = null;

  useEffect(() => {
    if (hovering && GalleryImages.length > 1) {
      timerRef = setTimeout(() => {
        setCurrentImgIndex(
          (prevIndex) => (prevIndex + 1) % GalleryImages.length
        );
      }, 1100); // Change image every 1.1 seconds
    }

    return () => clearTimeout(timerRef);
  }, [hovering, currentImgIndex, GalleryImages.length]);

  const productContent = (
    <div className="productlist">
      <div
        className="imgbox relative"
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => {
          setHovering(false);
          setCurrentImgIndex(0); // Reset to first image on mouse leave
        }}
      >
        {e.featured === 1 && <span className="best_seller">Best Seller</span>}
        {e.discount > 0 && <span className="onsale">Sale!</span>}
        {e.current_stock < 1 && (
          <div className="out-of-stock-custom">Sold Out</div>
        )}

        <AddtoWishlist p_id={e.id} />

        {e?.reviews_count > 0 && (
          <Rating totCount={e?.reviews_count} reviews={e?.reviews} />
        )}

        {/* <Link to={`/product/${e.slug}`} target="_blank" rel="noopener noreferrer"> */}
        <Link to={`/product/${e.slug}`} >
          {GalleryImages.length > 0 && (
            <LazyLoadImage
              src={`${process.env.REACT_APP_IMAGE_URL}product/thumbnail/${GalleryImages[currentImgIndex]}`}
              alt={e.name}
              title={e.name}
              className="defaultimg transition-opacity duration-500 ease-in-out"
              loading="lazy"
             /*  width="500px"
              height="699px" */
              effect="blur"
            />           
          )}
        </Link>

        {/* Dot Indicators (Now positioned at the bottom-left) */}
        {GalleryImages.length > 1 && (
          <div className="absolute bottom-2 left-2 flex space-x-1">
            {GalleryImages.map((_, index) => (
              <span
                key={index}
                className={`w-3 h-3 rounded-full cursor-pointer transition-all duration-300 ${currentImgIndex === index
                  ? "bg-red scale-110"
                  : "bg-red-800 opacity-60"
                  }`}
                onClick={() => setCurrentImgIndex(index)}
              ></span>
            ))}
          </div>
        )}
      </div>

      <div className="producttitle">
        <h2>
          <Link to={`/product/${e.slug}`}>
            {e.name.length > 40 ? e.name.substring(0, 40) + "..." : e.name}
          </Link>
        </h2>
        {e.unit_price && (
          <PriceHtml
            pdata={{
              discount: e.discount,
              discount_type: e.discount_type,
              price: e.unit_price,
              symbol: symbol,
              divclass: "price-box",
              shipping_time: e.shipping_time,
              pagefrom: "productlist",
            }}
          />
        )}
      </div>
    </div>
  );

  const content = ref ? (
    <div className="col-md-4 col-sm-6 col-xs-12 mb-40" ref={ref}>
      {productContent}
    </div>
  ) : (
    <div className="col-md-4 col-sm-6 col-xs-12 mb-40">{productContent}</div>
  );
  return content;
});

export default ProductCard;
